export const detectZoom = () => {
  // const wH = window.innerHeight; // 当前窗口的高度
  const wW = window.innerWidth; // 当前窗口的宽度
  // const rem = wW * basePc; // 以默认比例值乘以当前窗口宽度,得到该宽度下的相应FONT-SIZE值
  const html = document.documentElement;
  const cW = html.clientWidth, cH = html.clientHeight;
  const basePc = cW > 750 ? 100 / 1920 : 100/750; // 表示1920的设计图,使用100PX的默认值
  const rem2 = cW*basePc;
  window.FontSize = rem2;
  document.documentElement.style.fontSize = rem2 + "px"; //适用于PC网站
  return wW > 750 ? true : false;
};




// WEBPACK FOOTER //
// ./src/utils/detectZoom.js